import script from "./ImageCollectionPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImageCollectionPreview.vue?vue&type=script&lang=ts&setup=true"

import "./ImageCollectionPreview.vue?vue&type=style&index=0&id=2790108b&scoped=true&lang=scss"

import exportComponent from "/var/icar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2790108b"]])

export default __exports__